import React from 'react';
import { Mail, MapPin, Phone } from 'lucide-react';

function Contact({ onBack }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a1628] via-[#1a2942] to-[#0d47a1] text-white">
      {/* Navigation */}
      <nav className="flex justify-between items-center px-16 py-6 relative z-10">
        <div className="flex items-center gap-3">
          <img src="/logo.png" alt="TwoRun.AI Logo" className="w-12 h-12 object-contain" />
          <span className="text-2xl font-bold">TwoRun.AI</span>
        </div>
        
        <div className="flex gap-4">
          <button 
            onClick={onBack}
            className="px-6 py-2 border border-white/30 rounded-lg hover:border-white hover:bg-white/10 transition-all"
          >
            ← Back to Home
          </button>
        </div>
      </nav>

      {/* Contact Content */}
      <div className="max-w-4xl mx-auto px-8 py-16">
        <h1 className="text-5xl font-bold mb-6 text-center bg-gradient-to-r from-white to-blue-200 bg-clip-text text-transparent">
          Get in Touch
        </h1>
        
        <p className="text-xl text-white/70 text-center mb-16 max-w-2xl mx-auto">
          Ready to transform your business with AI? Contact us today to learn more about TwoRun.AI solutions.
        </p>

        <div className="grid md:grid-cols-1 gap-8 mb-16">
          <div className="bg-white/10 backdrop-blur-xl rounded-2xl p-8 border border-white/20 text-center">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-blue-500/20 rounded-full flex items-center justify-center">
                <Mail className="w-8 h-8 text-blue-400" />
              </div>
            </div>
            <h3 className="text-2xl font-bold mb-3">Email Us</h3>
            <a 
              href="mailto:sales@tworun.ai" 
              className="text-blue-400 hover:text-blue-300 text-xl font-semibold transition-colors"
            >
              sales@tworun.ai
            </a>
            <p className="text-white/60 mt-3">
              We'll respond within 24 hours
            </p>
          </div>
        </div>

        <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
          <h2 className="text-3xl font-bold mb-6 text-center">Why Choose TwoRun.AI?</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="text-4xl mb-3">🔒</div>
              <h4 className="font-bold mb-2">Secure & Private</h4>
              <p className="text-white/60 text-sm">Your data stays on local servers</p>
            </div>
            <div className="text-center">
              <div className="text-4xl mb-3">⚡</div>
              <h4 className="font-bold mb-2">Fast Integration</h4>
              <p className="text-white/60 text-sm">Quick deployment process</p>
            </div>
            <div className="text-center">
              <div className="text-4xl mb-3">🎯</div>
              <h4 className="font-bold mb-2">Customized AI</h4>
              <p className="text-white/60 text-sm">Trained on your business data</p>
            </div>
          </div>
        </div>

        <div className="text-center mt-16">
          <p className="text-white/60 mb-6">
            Want to learn more about our AI model training services?
          </p>
          <a 
            href="https://oawo.co.uk/en/page/ai-model-training"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-8 py-4 bg-blue-500 rounded-xl font-semibold hover:bg-blue-600 hover:-translate-y-1 hover:shadow-2xl hover:shadow-blue-500/40 transition-all"
          >
            Explore AI Model Training
          </a>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[#0a1628] px-16 py-8 border-t border-white/10 mt-16">
        <div className="text-center">
          <p className="text-xs text-white/40">
            🚀 TwoRun.AI by OAWO Inc. & Baku Business Group 2025
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Contact;
